var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { feathersServices } from 'src/feathers';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import FormRound from './FormRound';
import ScorePrintOutGenerator from './ScorePrintOutGenerator';
var formStyles = require('src/imports/styles/extend.form.scss');
var selfStyles = require('../styles.scss');
var DashboardFormRound = (function (_super) {
    __extends(DashboardFormRound, _super);
    function DashboardFormRound(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePatchRound = _this.handlePatchRound.bind(_this);
        return _this;
    }
    DashboardFormRound.prototype.handlePatchRound = function (round) {
        return this.props.dispatch(feathersServices.rounds.patch(round.id, round));
    };
    DashboardFormRound.prototype.render = function () {
        var category = this.props.workspaceEvent.category;
        var round = this.props.workspaceEvent.round;
        if (!category || !round) {
            return null;
        }
        return (React.createElement(Card, { className: formStyles.card },
            React.createElement("h2", { className: formStyles.header + " " + selfStyles.cardHeader },
                "Settings for ",
                round.name,
                ", ",
                category.name),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 24 },
                    React.createElement(FormRound, { round: round, handlePatchRound: this.handlePatchRound }))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 24 },
                    React.createElement(ScorePrintOutGenerator, null)))));
    };
    return DashboardFormRound;
}(React.Component));
var mapStateToProps = function (state) {
    var categoryId = state.scoreboard.categoryId;
    var roundId = state.scoreboard.roundId;
    return {
        workspaceEvent: {
            category: state.workspaceEvent.categories && state.workspaceEvent.categories.data.find(function (c) { return c.id === categoryId; }),
            round: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data.find(function (r) { return r.id === roundId; }),
        },
    };
};
export default connect(mapStateToProps)(DashboardFormRound);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/DashboardForm/DashboardFormRound/index.tsx
// module id = 971
// module chunks = 0